import loader from '../assets/loader.gif'

const Loader = () => {
    return <img src={loader} alt='loading' />
}

export default Loader